import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const PresentIcon = (props: IconProps) => {
  return (
    <Icon fill="none" viewBox="0 0 20 20" {...props}>
      <path d="M9 5v4l3-2-3-2Z" fill="#fff" />
      <path
        d="M1 .25a.75.75 0 1 0 0 1.5V.25Zm18 1.5a.75.75 0 0 0 0-1.5v1.5ZM18 13v.75c.41 0 .75-.34.75-.75H18ZM2 13h-.75c0 .41.34.75.75.75V13Zm3.29 5.76a.75.75 0 0 0 1.42.48l-1.42-.48Zm8 .48a.75.75 0 0 0 1.42-.48l-1.42.48ZM9 9h-.75a.75.75 0 0 0 1.17.62L9 9Zm0-4 .42-.62A.75.75 0 0 0 8.25 5H9Zm3 2 .42.62a.75.75 0 0 0 0-1.24L12 7ZM1 1.75h1V.25H1v1.5Zm18-1.5h-1v1.5h1V.25ZM17.25 1v12h1.5V1h-1.5ZM18 12.25h-6v1.5h6v-1.5Zm0-12H2v1.5h16V.25ZM1.25 1v12h1.5V1h-1.5ZM2 13.75h6v-1.5H2v1.5Zm5.29-.99-2 6 1.42.48 2-6-1.42-.48Zm.71.99h4v-1.5H8v1.5Zm3.29-.51 2 6 1.42-.48-2-6-1.42.48ZM9.75 9V5h-1.5v4h1.5ZM8.58 5.62l3 2 .84-1.24-3-2-.84 1.24Zm3 .76-3 2 .84 1.24 3-2-.84-1.24Z"
        fill="#fff"
      />
    </Icon>
  );
};

export default PresentIcon;
